import doctors from 'assets/images/icons/doctors.jpg';
import phone from 'assets/images/phone.svg';
import fundingSourcePassive from 'assets/images/icons/fundingSourcePassive.svg';
import fundingSourceActive from 'assets/images/icons/fundingSourceActive.svg';
import staffActive from 'assets/images/icons/staffActive.svg';
import staffPassive from 'assets/images/icons/staffPassive.svg';
import addCircle from 'assets/images/icons/addCircle.svg';
import fundingSourceOutline from 'assets/images/icons/fundingSourceOutline.svg';
import staffOutline from 'assets/images/icons/staffOutline.svg';
import roleManagementActive from 'assets/images/icons/roleManagementActive.svg';
import roleManagementPassive from 'assets/images/icons/roleManagementPassive.svg';
import addYellowIcon from 'assets/images/icons/addYellowIcon.svg';
import employment from 'assets/images/icons/employment.svg';
import removeIcon from 'assets/images/icons/removeIcon.svg';
import error from 'assets/images/icons/error.svg';
import aToZ from 'assets/images/icons/aToZ.svg';
import zToA from 'assets/images/icons/zToA.svg';
import checked from 'assets/images/icons/checked.svg';
import userProfile from 'assets/images/icons/userProfile.svg';
import email from 'assets/images/icons/email.svg';
import bluePhone from 'assets/images/icons/phone.svg';
import location from 'assets/images/icons/location.svg';
import clientProggressReport from 'assets/images/icons/clientProggressReport.svg';
import clientNotesDock from 'assets/images/icons/clientNotesDock.svg';
import clientSessionNotesDock from 'assets/images/icons/clientSessionNotesDock.svg';
import formHistory from 'assets/images/icons/formHistory.svg';
import messageCircle from 'assets/images/icons/messageCircle.svg';
import messageCircleBlue from 'assets/images/icons/messageCircleBlue.svg';
import assignedStaff from 'assets/images/icons/assignedStaff.svg';
import setupGuide from 'assets/images/icons/setupGuide.svg';
import checkedVerify from 'assets/images/icons/checkedVerify.svg';
import systemAllyGuide from 'assets/images/icons/systemAllyGuide.png';
import sftpIntegration from 'assets/images/icons/sftpIntegration.png';
import isReadyGreen from 'assets/images/icons/isReadyGreen.svg';
import availityWeb from 'assets/images/icons/avalityWeb.png';
import ftpAndEdi from 'assets/images/icons/ftpAndEdi.png';
import manageFtp from 'assets/images/icons/manageFtp.png';
import createAccountAvaility from 'assets/images/icons/createAccountAvaility.png';
import availityIntegrated from 'assets/images/icons/availityIntegrated.png';
// import edit from 'assets/images/icons/edit.svg';
import edit from 'assets/images/icons/editDarkBlue.svg';
import signOut from 'assets/images/icons/signOut.svg';
import generalInfoIcon from 'assets/images/icons/generalInfo.svg';
import address from 'assets/images/icons/address.svg';
import otherDetailsIcon from 'assets/images/icons/otherDetails.svg';
import remove from 'assets/images/icons/remove.svg';
import addLight from 'assets/images/icons/addLight.svg';
import addLight2 from 'assets/images/icons/addLight2.svg';
import clientActive from 'assets/images/icons/clientActive.svg';
import clients from 'assets/images/icons/clients.svg';
import clientsPassive from 'assets/images/icons/clientsPassive.svg';
import clientModalicon1 from 'assets/images/icons/clientModal1.svg';
import clientModalicon2 from 'assets/images/icons/clientModal2.svg';
import clientModalicon3 from 'assets/images/icons/clientModal3.svg';
import checkmark from 'assets/images/icons/checkmark.svg';
import systemActive from 'assets/images/icons/systemActive.svg';
import systemPassive from 'assets/images/icons/systemPassive.svg';
import systemIcon from 'assets/images/icons/systemIcon.svg';
import authIcon from 'assets/images/icons/authIcon.svg';
import errorIcon from 'assets/images/icons/errorIcon.svg';
import successIcon from 'assets/images/icons/successIcon.svg';
import infoIcon from 'assets/images/icons/informationIcon.svg';
import addHours from 'assets/images/icons/addHours.svg';
import authIconGen from 'assets/images/icons/authIconGen.svg';
import addIcon from 'assets/images/icons/Add.svg';
import fileIcon from 'assets/images/icons/fileIcon.svg';
import eventsFill from '../assets/images/icons/eventsFill.svg';
import download from '../assets/images/icons/download.svg';
import forward from '../assets/images/icons/forward.svg';
import authEdit from 'assets/images/icons/authEdit.svg';
import recurrance from 'assets/images/icons/recurrance.svg';
import pngIcon from 'assets/images/icons/pngIcon.svg';
import jpegIcon from 'assets/images/icons/jpegIcon.svg';
import pdfIcon from 'assets/images/icons/pdfIcon.svg';
import csvIcon from 'assets/images/icons/csvIcon.svg';
import eventsPassive from 'assets/images/icons/eventsPassive.svg';
import accessManagementFill from 'assets/images/icons/accessManagementFill.svg';
import accessManagementOutline from 'assets/images/icons/accessManagementOutline.svg';
import dropdownArrow from 'assets/images/icons/dropdownArrow.svg';
import dropdownArrowBlue from 'assets/images/icons/dropdownArrowBlue.svg';
import search from 'assets/images/icons/search.svg';
import checkmarkWhite from 'assets/images/icons/checkmarkWhite.svg';
import dropdownArrowFilledBlue from 'assets/images/icons/dropdownArrowFilledBlue.svg';
import billingFill from 'assets/images/icons/billingFill.svg';
import billingPassive from 'assets/images/icons/billingPassive.svg';
import accordArrowBlue from 'assets/images/icons/accordArrowBlue.svg';
import accordArrowBlack from 'assets/images/icons/accordArrowBlack.svg';
import latestEarliest from 'assets/images/icons/latestEarliest.svg';
import billingOutline from 'assets/images/icons/billingOutline.svg';
import addOrange from 'assets/images/icons/addOrange.svg';
import aToZWhite from 'assets/images/icons/aToZWhite.svg';
import latestEarliestWhite from 'assets/images/icons/latestEarliestWhite.svg';
import dropdownArrowWhite from 'assets/images/icons/dropdownArrowWhite.svg';
import claimInfo from 'assets/images/icons/claimInfo.svg';
import checkmarkBlue from 'assets/images/icons/checkmarkBlue.svg';
import uncheck from 'assets/images/icons/uncheck.svg';
import postingFill from 'assets/images/icons/postingFill.svg';
import postingPassive from 'assets/images/icons/postingPassive.svg';
import success from 'assets/images/icons/success.svg';
import successGreen from 'assets/images/icons/successGreen.svg';
import editPmt from 'assets/images/icons/editPmt.svg';
import forwardBlue from 'assets/images/icons/forwardBlue.svg';
import addLightIcon from 'assets/images/icons/addLightIcon.svg';
import infoWhiteIcon from 'assets/images/icons/infoWhiteIcon.svg';
import warning from 'assets/images/icons/warning.svg';
import earliestLatestBlue from 'assets/images/icons/earliestLatestBlue.svg';
import show from 'assets/images/icons/show.svg';
import toolInfo from 'assets/images/icons/toolInfo.svg';
import addBluePlus from 'assets/images/icons/addBluePlus.svg';
import plusSimple from 'assets/images/icons/plusSimple.svg';
import plus from 'assets/images/icons/plus.svg';
import moreInfo from 'assets/images/icons/moreInfo.svg';
import portfolio from 'assets/images/icons/portfolio.svg';
import bigEmployment from 'assets/images/icons/bigEmployment.svg';
import greenMark from 'assets/images/icons/greenMark.svg';
import aboutInformation from 'assets/images/icons/aboutInformation.svg';
import upload from 'assets/images/icons/upload.svg';
import document from 'assets/images/icons/document.svg';
import deleteDock from 'assets/images/icons/deleteDock.svg';
import editDock from 'assets/images/icons/editDock.svg';
import downloadDock from 'assets/images/icons/downloadDock.svg';
import showDock from 'assets/images/icons/showDock.svg';
import hours from 'assets/images/icons/hours.svg';
import closeVector from 'assets/images/icons/closeVector.svg';
import bigDownload from 'assets/images/icons/bigDownload.svg';
import addIconAndCircle from 'assets/images/icons/addIconAndCircule.svg';
import reportGray from 'assets/images/icons/reportGray.svg';
import reportBlue from 'assets/images/icons/reportBlue.svg';
import downloadPdf from 'assets/images/icons/downloadPdf.svg';
import reportsTab from 'assets/images/icons/reportsTab.svg';
import logo from 'assets/images/icons/logo.svg';
import blueBlackLogo from 'assets/images/icons/blueBlackLogo.svg';
import payrollActive from 'assets/images/icons/payrollActive.svg';
import payrollPassive from 'assets/images/icons/payrollPassive.svg';
import east from 'assets/images/icons/east.svg';
import editGray from 'assets/images/icons/editGray.svg';
import dropDown from 'assets/images/icons/dropDown.svg';
import dropUp from 'assets/images/icons/dropUp.svg';
import time from 'assets/images/icons/time.svg';
import locationGray from 'assets/images/icons/locationGray.svg';
import starVector from 'assets/images/icons/starVector.svg';
import toolInfoBlack from 'assets/images/icons/toolInfoBlack.svg';
import dropdownArrowUpBlue from 'assets/images/icons/dropdownArrowUpBlue.svg';
import dropdownBlue from 'assets/images/icons/dropdownBlue.svg';
import lock from 'assets/images/icons/lock.svg';
import unlock from 'assets/images/icons/unlock.svg';
import insurance from 'assets/images/icons/insurance.svg';
import emailGray from 'assets/images/icons/emailGray.svg';
import call from 'assets/images/icons/call.svg';
import verify from 'assets/images/icons/verify.svg';
import checkCredential from 'assets/images/icons/checkCredential.svg';
import uncheckCredential from 'assets/images/icons/uncheckCredential.svg';
import licenseIcon from 'assets/images/icons/licenseicon.svg';
import rightDropdownArrowBlue from 'assets/images/icons/rightDropdownArrowBlue.svg';
import selectCredential from 'assets/images/icons/selectCredential.svg';
import notes from 'assets/images/icons/notes.svg';
import grayCalendar from 'assets/images/icons/grayCalendar.svg';
import grayEdit from 'assets/images/icons/grayEdit.svg';
import uploadImage from 'assets/images/icons/uploadImage.svg';
import closeBlackVector from 'assets/images/icons/closeBlackVector.svg';
import reConnectedTemplate from 'assets/images/icons/reConnectedTemplate.svg';
import connectedTemplate from 'assets/images/icons/connectedTemplate.svg';
import apptGeneralInfo from 'assets/images/icons/apptGeneralInfo.png';
import repetAppt from 'assets/images/icons/repetAppt.png';
import repetApptBlue from 'assets/images/icons/repetApptBlue.png';
import office from 'assets/images/icons/office.svg';
import reinvite from 'assets/images/icons/reinvite.svg';
import scheduleTime from 'assets/images/icons/scheduleTime.svg';
import scheduleGroup from 'assets/images/icons/scheduleGroup.svg';
import scheduleList from 'assets/images/icons/scheduleList.svg';
import link from 'assets/images/icons/link.svg';
import externalLink from 'assets/images/icons/externalLink.svg';
import note from 'assets/images/icons/note.svg';
import cloudUpload from 'assets/images/icons/cloudUpload.svg';
import pastAuthorizations from 'assets/images/icons/pastAuthorizations.svg';
import googleCalendar from 'assets/images/icons/googleCalendar.svg';
import appleCalendar from 'assets/images/icons/appleCalendar.svg';
import accessTime from 'assets/images/icons/accessTime.svg';
import filters from 'assets/images/icons/filters.svg';
import arrowRight from 'assets/images/icons/arrowRight.svg';
import calendarToday from 'assets/images/icons/calendarToday.svg';
import expandFull from 'assets/images/icons/expandFull.svg';
import timelapse from 'assets/images/icons/timelapse.svg';
import minimize from 'assets/images/icons/minimize.svg';
import logoSmall from 'assets/images/icons/logoSmall.svg';
import downloadCloud from 'assets/images/icons/downloadCloud.svg';
import authUtilization from 'assets/images/icons/authUtilization.svg';
import downloadCloudWhite from 'assets/images/icons/downloadCloudWhite.svg';
import accessManagementIcon from 'assets/images/icons/accessManagementIcon.svg';
import sms from 'assets/images/icons/sms.svg';
import callCalling from 'assets/images/icons/callCalling.svg';
import grayLocation from 'assets/images/icons/grayLocation.svg';
import tableSortBlue from 'assets/images/icons/tableSortBlue.svg';
import tableSortGray from 'assets/images/icons/tableSortGray.svg';
import client from 'assets/images/icons/user.svg';
import accessManagementOutlineGray from 'assets/images/icons/accessManagementOutlineGray.svg';
import alertTriangle from 'assets/images/icons/alertTriangle.svg';
import removeAddress from 'assets/images/icons/removeAddress.svg';
import noteClock from 'assets/images/icons/noteClock.svg';
import noteCalendar from 'assets/images/icons/noteCalendar.svg';
import noteEdit from 'assets/images/icons/noteEdit.svg';
import editTemplate from 'assets/images/icons/editTemplate.svg';
import staffPosition from 'assets/images/icons/staffPosition.svg';
import documentUpload from 'assets/images/icons/documentUpload.svg';
import timePast from 'assets/images/icons/timePast.svg';
import deleteLicenseIcon from 'assets/images/icons/deleteLicenseIcon.svg';
import editBlack from 'assets/images/icons/editBlack.svg';
import hideEye from 'assets/images/icons/hideEye.svg';
import showEye from 'assets/images/icons/showEye.svg';
import noFile from 'assets/images/icons/noFile.svg';
import CSVFile from 'assets/images/icons/CSVFile.svg';
import JPEGFile from 'assets/images/icons/JPEGFile.svg';
import PDFFile from 'assets/images/icons/PDFFile.svg';
import PNGFile from 'assets/images/icons/PNGFile.svg';
import authFile from 'assets/images/icons/authFile.svg';
import uploadAvatar from 'assets/images/icons/uploadAvatar.svg';
import closeButton from 'assets/images/icons/closeButton.svg';
import darkGrayDone from 'assets/images/icons/darkGrayDone.svg';
import trash from 'assets/images/icons/trash.svg';
import uploadCloud from 'assets/images/icons/uploadCloud.svg';
import uploadTrayBlue from 'assets/images/icons/uploadTrayBlue.svg';
import uploadedFile from 'assets/images/icons/uploadedFile.svg';
import complete from 'assets/images/icons/complete.svg';
import grayTrash from 'assets/images/icons/grayTrush.svg';
import fsIcon from 'assets/images/icons/fsIcon.svg';
import billingTab from 'assets/images/icons/leftBar/billingTab.svg';
import clientTab from 'assets/images/icons/leftBar/clientTab.svg';
import dashboardTab from 'assets/images/icons/leftBar/dashboardTab.svg';
import dashboardTabActive from 'assets/images/icons/leftBar/dashboardTabActive.svg';
import fsTab from 'assets/images/icons/leftBar/fsTab.svg';
import payrollTab from 'assets/images/icons/leftBar/payrollTab.svg';
import postingTab from 'assets/images/icons/leftBar/postingTab.svg';
import reportTab from 'assets/images/icons/leftBar/reportTab.svg';
import roleTab from 'assets/images/icons/leftBar/roleTab.svg';
import scheduleTab from 'assets/images/icons/leftBar/scheduleTab.svg';
import staffTab from 'assets/images/icons/leftBar/staffTab.svg';
import systemTab from 'assets/images/icons/leftBar/systemTab.svg';
import resourceTab from 'assets/images/icons/leftBar/resourceTab.svg';
import resourceTabActive from 'assets/images/icons/leftBar/resourceTabActive.svg';
import toolsTab from 'assets/images/icons/leftBar/toolsTab.svg';
import toolsTabActive from 'assets/images/icons/leftBar/toolsTabActive.svg';
import libraryTab from 'assets/images/icons/leftBar/libraryTab.svg';
import libraryTabActive from 'assets/images/icons/leftBar/libraryTabActive.svg';
import chatSupport from 'assets/images/icons/leftBar/chatSupport.svg';
import leftSideIcon from 'assets/images/icons/leftBar/leftSideIcon.svg';
import redTrash from 'assets/images/icons/redTrash.svg';
import billingTabActive from 'assets/images/icons/leftBar/billingTabActive.svg';
import clientTabActive from 'assets/images/icons/leftBar/clientTabActive.svg';
import fsTabActive from 'assets/images/icons/leftBar/fsTabActive.svg';
import payrollTabActive from 'assets/images/icons/leftBar/payrollTabActive.svg';
import postingTabActive from 'assets/images/icons/leftBar/postingTabActive.svg';
import reportTabActive from 'assets/images/icons/leftBar/reportTabActive.svg';
import roleTabActive from 'assets/images/icons/leftBar/roleTabActive.svg';
import scheduleTabActive from 'assets/images/icons/leftBar/scheduleTabActive.svg';
import staffTabActive from 'assets/images/icons/leftBar/staffTabActive.svg';
import systemTabActive from 'assets/images/icons/leftBar/systemTabActive.svg';
import uploadCloudBlack from 'assets/images/icons/uploadCloudBlack.svg';
import editDockBlack from 'assets/images/icons/editDockBlack.svg';
import checkMarkBlack from 'assets/images/icons/checkMarkBlack.svg';
import flag from 'assets/images/icons/flag.svg';
import yellowFlag from 'assets/images/icons/yellowFlag.svg';
import refresh from 'assets/images/icons/refresh.svg';
import downloadCloudBlue from 'assets/images/icons/downloadCloudBlue.svg';
import whiteInfoIcon from 'assets/images/icons/whiteInfoIcon.svg';
import generateInfoIcon from 'assets/images/icons/generateInfoIcon.svg';
import blueFlag from 'assets/images/icons/blueFlag.svg';
import noAppt from 'assets/images/icons/notYet/noAppt.svg';
import noFsYet from 'assets/images/icons/notYet/noFsYet.svg';
import noClientYet from 'assets/images/icons/notYet/noCLientYet.svg';
import noNote from 'assets/images/icons/notYet/noNote.svg';
import noHistory from 'assets/images/icons/notYet/noHistory.svg';
import notFile from 'assets/images/icons/notYet/notFile.svg';
import noService from 'assets/images/icons/notYet/noService.svg';
import noContact from 'assets/images/icons/notYet/noContact.svg';
import noAccess from 'assets/images/icons/notYet/noAccess.svg';
import noDashboard from 'assets/images/icons/notYet/noDashboard.svg';
import noPendingClaim from 'assets/images/icons/notYet/noPendingClaim.svg';
import noCalendar from 'assets/images/icons/notYet/noCalendar.svg';
import noRole from 'assets/images/icons/notYet/noRole.svg';
import noCredential from 'assets/images/icons/notYet/noCredential.svg';
import emptyFolder from 'assets/images/icons/notYet/emptyFolder.svg';
import noUpcomingAppointment from 'assets/images/icons/notYet/noUpcomingAppointment.svg';
import manageNote from 'assets/images/icons/manageNote.svg';
import uploadSignature from 'assets/images/icons/uploadSignature.svg';
import editDark from 'assets/images/icons/editDark.svg';
import recurDark from 'assets/images/icons/recurDark.svg';
import toolInfoIcon from 'assets/images/icons/toolInfoIcon.svg';
import folder from 'assets/images/icons/folder.svg';
import showAyeBlue from 'assets/images/icons/showAyeBlue.svg';
import addBlackIcon from 'assets/images/icons/addBlackIcon.svg';
import editPen from 'assets/images/icons/editPen.svg';
import copy from 'assets/images/icons/copy.svg';
import inactivatePayCode from 'assets/images/icons/inactivatePaycode.svg';
import staffCredential from 'assets/images/icons/staffCredential.svg';
import fsClients from 'assets/images/icons/fsClients.svg';
import removeBlack from 'assets/images/icons/removeBlack.svg';
import signatureIcon from 'assets/images/icons/signatureIcon.svg';
import alreadyUploadedSignatureIcon from 'assets/images/icons/alreadyUploadedSignatureIcon.svg';
import clearSignature from 'assets/images/icons/clearSignature.svg';
import signatureDate from 'assets/images/icons/signatureDate.svg';
import signatureFile from 'assets/images/icons/signatureFile.svg';
import signatureLocation from 'assets/images/icons/signatureLocation.svg';
import notification from 'assets/images/icons/notification.svg';
import danger from 'assets/images/icons/danger.svg';
import noNotifications from 'assets/images/icons/noNotifications.svg';
import newServiceAdded from 'assets/images/icons/newServiceAdded.svg';
import newApptCreated from 'assets/images/icons/newApptCreated.svg';
import apptEdited from 'assets/images/icons/apptEdited.svg';
import apptCancelled from 'assets/images/icons/apptCancelled.svg';
import apptAlert from 'assets/images/icons/apptAlert.svg';
import apptComplete from 'assets/images/icons/apptComplete.svg';
import generateReport from 'assets/images/icons/generateReport.svg';
import generateReportWhite from 'assets/images/icons/generateReportWhite.svg';
import searchIcon from 'assets/images/icons/searchIcon.svg';
import closeGray from 'assets/images/icons/closeGray.svg';
import trendUp from 'assets/images/icons/trendUp.svg';
import trendDown from 'assets/images/icons/trendDown.svg';

import checkCircleBlue from 'assets/images/icons/checkCircleBlue.svg';
import claimSubmitP from 'assets/images/icons/claimSubmitP.svg';
import claimSubmitI from 'assets/images/icons/claimSubmitI.svg';
import claimSubmitD from 'assets/images/icons/claimSubmitD.svg';

import masteredTarget from 'assets/images/icons/masteredTarget.svg';
import linkIcon from 'assets/images/icons/linkIcon.svg';
import archive from 'assets/images/icons/archive.svg';
import unarchive from 'assets/images/icons/unarchive.svg';
import builder from 'assets/images/icons/builder.svg';
import formPreview from 'assets/images/icons/formPreview.svg';
import sectionFolder from 'assets/images/icons/sectionFolder.svg';
import formRichText from 'assets/images/icons/formRichText.svg';
import supervizeEye from 'assets/images/icons/supervizeEye.svg';
import supervizeBigEye from 'assets/images/icons/supervizeBigEye.svg';
import lockSmallGreen from 'assets/images/icons/lockSmallGreen.svg';
import checkedMarkGreen from 'assets/images/icons/checkedMarkGreen.svg';
import checkTickGreen from 'assets/images/icons/checkTickGreen.svg';
import signIcon from 'assets/images/icons/signIcon.svg';
import secondaryNotBilledFlag from 'assets/images/icons/secondaryNotBilledFlag.svg';
import replyIcon from 'assets/images/icons/replyIcon.svg';
import commentChatIcon from 'assets/images/icons/commentChatIcon.svg';
import dollarIcon from 'assets/images/icons/dollarIcon.svg';
import otherSettingsAi from 'assets/images/icons/otherSettingsAi.svg';
import otherSettingsBcba from 'assets/images/icons/otherSettingsBcba.svg';
import otherSettingsElig from 'assets/images/icons/otherSettingsElig.svg';
import clientAbcData from 'assets/images/icons/clientAbcData.svg';
import staffCompliance from 'assets/images/icons/staffCompliance.svg';

import clientWidget from 'assets/images/widgets/clientWidget.svg';
import fsWidget from 'assets/images/widgets/fsSourceWidget.svg';
import payrollWidget from 'assets/images/widgets/payrollWigdet.svg';
import staffWidgets from 'assets/images/widgets/staffWidgets.svg';
import apptWidget from 'assets/images/widgets/apptWidget.svg';
import addCircleBlue from 'assets/images/icons/addCircleBlue.svg';
import added from 'assets/images/icons/added.svg';
import noAnalyticYet from 'assets/images/icons/noAnalyticYet.svg';
import barChart from 'assets/images/icons/barChart.svg';
import lineChart from 'assets/images/icons/lineChart.svg';
import pieChart from 'assets/images/icons/pieChart.svg';
import dragIndicator from 'assets/images/icons/dragIndicator.svg';
import dragIndicatorBlue from 'assets/images/icons/dragIndicatorBlue.svg';
import moreGray from 'assets/images/icons/moreGray.svg';
import deleteTag from 'assets/images/icons/deleteTag.svg';
import tagUser from 'assets/images/icons/tagUser.svg';
import closeChip from 'assets/images/icons/closeChip.svg';
import closeChipBlue from 'assets/images/icons/closeChipBlue.svg';
import officeAlly from 'assets/images/icons/officeAlly.svg';
import compareArrows from 'assets/images/icons/compareArrows.svg';
import selectAll from 'assets/images/icons/selectAll.svg';
import closeExWhite from 'assets/images/icons/closeExWhite.svg';
import helpIcon from 'assets/images/icons/helpIcon.svg';
import helpIconActive from 'assets/images/icons/helpIconActive.svg';
import onlineSupport from 'assets/images/icons/onlineSupport.svg';
import coinStack from 'assets/images/icons/coinStack.svg';
import signatureRemove from 'assets/images/icons/signatureRemove.svg';
import refreshSelect from 'assets/images/icons/refreshSelect.svg';
import businessCenter from 'assets/images/icons/businessCenter.svg';
import copyAuth from 'assets/images/icons/copyAuth.svg';
import editAuth from 'assets/images/icons/editAuth.svg';
import fileAuth from 'assets/images/icons/fileAuth.svg';
import xCircle from 'assets/images/icons/xCircle.svg';
import save from 'assets/images/icons/save.svg';
import apptCalendar from 'assets/images/icons/apptCalendar.svg';
import moreGrayIcon from 'assets/images/icons/moreGrayIcon.svg';
import repeatAppt from 'assets/images/icons/repeatAppt.svg';
import arrowOrangeRight from 'assets/images/icons/arrowOrangeRight.svg';
import alertError from 'assets/images/icons/alertError.svg';
import alertWarning from 'assets/images/icons/alertWarning.svg';
import apptNoteIcon from 'assets/images/icons/apptNoteIcon.svg';
import officeNotes from 'assets/images/icons/officeNotes.svg';
import tableNotes from 'assets/images/icons/tableNotes.svg';
import clinicalNote from 'assets/images/icons/clinicalNote.svg';
import toolOfficeNote from 'assets/images/icons/toolOfficeNote.svg';
import toolClinicalNote from 'assets/images/icons/toolClinicalNote.svg';
import editDarkBlue from 'assets/images/icons/editDarkBlue.svg';
import emptyStateIllustrations from 'assets/images/icons/emptyStateIllustrations.svg';
import primaryStar from 'assets/images/icons/primaryStar.svg';
import calendar from 'assets/images/icons/calendar.svg';
import arrowUp from 'assets/images/icons/arrowUp.svg';
import arrowDown from 'assets/images/icons/arrowDown.svg';
import pastEmployment from 'assets/images/icons/pastEmployment.svg';
import actualTime from 'assets/images/icons/actualTime.svg';
import actualTimeWhite from 'assets/images/icons/actualTimeWhite.svg';
import revertIcon from 'assets/images/icons/revertIcon.svg';
import clientOfficeNote from 'assets/images/icons/clientOfficeNote.svg';
import sessionOfficeNote from 'assets/images/icons/sessionOfficeNote.svg';
import briefcase from 'assets/images/icons/briefcase.svg';
import uploadDockCloud from 'assets/images/icons/uploadDockCloud.svg';
import duplicate from 'assets/images/icons/duplicate.svg';
import chevronDown from 'assets/images/icons/chevronDown.svg';
import signaturePenBlue from 'assets/images/icons/signaturePenBlue.svg';
import signedSuccessCheck from 'assets/images/icons/signedSuccessCheck.svg';
import shieldTickGray from 'assets/images/icons/shieldTickGray.svg';
import redTrashLine from 'assets/images/icons/redTrashLine.svg';
import infoCircle from 'assets/images/icons/infoCircle.svg';
import infoCircleGray from 'assets/images/icons/infoCircleGray.svg';
import userPlus from 'assets/images/icons/userPlus.svg';
import userCheck from 'assets/images/icons/userCheck.svg';
import mail from 'assets/images/icons/mail.svg';
import stripe from 'assets/images/icons/stripe.svg';
import relatedLink from 'assets/images/icons/relatedLink.svg';
import cloeSafearea from 'assets/images/icons/cloeSafearea.svg';
import openSafearea from 'assets/images/icons/openSafearea.svg';
import closeSingleVector from 'assets/images/icons/closeSingleVector.svg';
import staffPassword from 'assets/images/icons/staffPassword.svg';
import completeIcon from 'assets/images/icons/completeIcon.svg';
import eyeWhite from 'assets/images/icons/eyeWhite.svg';
import undo from 'assets/images/icons/undo.svg';
import fileBlack from 'assets/images/icons/fileBlack.svg';
import revertWhite from 'assets/images/icons/revertWhite.svg';
import folderIcon from 'assets/images/icons/folderIcon.svg';
import folderMain from 'assets/images/icons/folderMain.svg';
import layer from 'assets/images/icons/layer.svg';
import pieLineChart from 'assets/images/icons/pieLineChart.svg';
import insightsChart from 'assets/images/icons/insightsChart.svg';
import userCheckEligibility from 'assets/images/icons/userCheckEligibility.svg';
import eligibilityChecked from 'assets/images/icons/eligibilityChecked.svg';
import eligibilityExpired from 'assets/images/icons/eligibilityExpired.svg';
import eligibilityFail from 'assets/images/icons/eligibilityFail.svg';
import eligibleNotes from 'assets/images/icons/eligibleNotes.svg';
import formTabActive from 'assets/images/icons/leftBar/formTabActive.svg';
import formTab from 'assets/images/icons/leftBar/formTab.svg';
import formIcon from 'assets/images/icons/formIcon.svg';
import fName from 'assets/images/form/fName.svg';
import fGoal from 'assets/images/form/fGoal.svg';
import fPhone from 'assets/images/form/fPhone.svg';
import fEmail from 'assets/images/form/fEmail.svg';
import fAddress from 'assets/images/form/fAddress.svg';
import fSignature from 'assets/images/form/fSignature.svg';
import fUpload from 'assets/images/form/fUpload.svg';
import fHeading from 'assets/images/form/fHeading.svg';
import fLongText from 'assets/images/form/fLongText.svg';
import fSingleLine from 'assets/images/form/fSingleLine.svg';
import fAvailability from 'assets/images/form/fAvailability.svg';
import fDatePicker from 'assets/images/form/fDatePicker.svg';
import fMultipleChoice from 'assets/images/form/fMultipleChoice.svg';
import fDivider from 'assets/images/form/fDivider.svg';
import fPageBreak from 'assets/images/form/fPageBreak.svg';
import backBtn from 'assets/images/icons/backBtn.svg';
import editSetting from 'assets/images/icons/editSetting.svg';
import duplicateFormLine from 'assets/images/icons/duplicateFormLine.svg';
import signatureHere from 'assets/images/icons/signatureHere.svg';
import minusCircle from 'assets/images/icons/minusCircle.svg';
import updateStatuses from 'assets/images/icons/updateStatuses.svg';
import defaultBadge from 'assets/images/icons/defaultBadge.svg';
import verifiedBadge from 'assets/images/icons/verifiedBadge.svg';
import verified from 'assets/images/icons/verified.svg';
import messageEdit from 'assets/images/icons/messageEdit.svg';
import providerIcon from 'assets/images/icons/providerIcon.svg';
import noteTab from 'assets/images/icons/noteTab.svg';
import historyTab from 'assets/images/icons/historyTab.svg';
import fileTab from 'assets/images/icons/fileTab.svg';
import commentCircle from 'assets/images/icons/commentCircle.svg';
import notAppealed from 'assets/images/icons/notAppealed.svg';
import appealed from 'assets/images/icons/appealed.svg';
import deleteFormItem from 'assets/images/icons/deleteFormItem.svg';
import startBuildingForm from 'assets/images/icons/startBuildingForm.svg';
import minusRemoveCircle from 'assets/images/icons/minusRemoveCircle.svg';
import formStaffNotes from 'assets/images/icons/formStaffNotes.svg';
import formAbcNotes from 'assets/images/icons/formAbcNotes.svg';
import formClientNotes from 'assets/images/icons/formClientNotes.svg';
import formInvoiceNotes from 'assets/images/icons/formInvoiceNotes.svg';
import formTimesheetNotes from 'assets/images/icons/formTimesheetNotes.svg';
import formClinicalNotes from 'assets/images/icons/formClinicalNotes.svg';
import formOfficeNotes from 'assets/images/icons/formOfficeNotes.svg';
import formFsNotes from 'assets/images/icons/formFsNotes.svg';
import formClaimNotes from 'assets/images/icons/formClaimNotes.svg';
import blockedForm from 'assets/images/icons/blockedForm.svg';
import warningInfo from 'assets/images/icons/warningInfo.svg';
import infoGrayIcon from 'assets/images/icons/infoGrayIcon.svg';
import backArrow from 'assets/images/icons/backArrow.svg';
import sessionGrid from 'assets/images/icons/sessionGrid.svg';
import sessionList from 'assets/images/icons/sessionList.svg';
import pauseCircle from 'assets/images/icons/pauseCircle.svg';
import pushPin from 'assets/images/icons/pushPin.svg';
import play from 'assets/images/icons/play.svg';
import stopCircle from 'assets/images/icons/stopCircle.svg';
import sessionTag from 'assets/images/icons/sessionTag.svg';
import sessionDomains from 'assets/images/icons/sessionDomains.svg';
import sessionTypes from 'assets/images/icons/sessionTypes.svg';
import sessionMode from 'assets/images/icons/sessionMode.svg';
import availity from 'assets/images/icons/availity.svg';
import checkCircleBlueTransparent from 'assets/images/icons/checkCircleBlueTransparent.svg';
import claimSubmitINotFill from 'assets/images/icons/claimSubmitINotFill.svg';
import claimSubmitDNotFill from 'assets/images/icons/claimSubmitDNotFill.svg';
import claimSubmitPNotFill from 'assets/images/icons/claimSubmitPNotFill.svg';
import slash from 'assets/images/icons/slash.svg';
import resetTimer from 'assets/images/icons/resetTimer.svg';
import arrowUpGray from 'assets/images/icons/arrowUpGray.svg';
import addAbc from 'assets/images/icons/addAbc.svg';
import eventCalendar from 'assets/images/icons/eventCalendar.svg';
import downloadTargetPdf from 'assets/images/icons/downloadTargetPdf.svg';
import filterAdd from 'assets/images/icons/filterAdd.svg';
import worked from 'assets/images/icons/worked.svg';
import truck from 'assets/images/icons/truck.svg';
import map from 'assets/images/icons/map.svg';
import apptsCalendar from 'assets/images/icons/apptsCalendar.svg';
import clock from 'assets/images/icons/clock.svg';
import personIcon from 'assets/images/icons/personIcon.svg';
import secondaryBilling from 'assets/images/icons/secondaryBilling.svg';
import secondaryBillingFilled from 'assets/images/icons/secondaryBillingFilled.svg';
import receipt from 'assets/images/icons/receipt.svg';
import payerPending from 'assets/images/icons/payerPending.svg';
import payerRejected from 'assets/images/icons/payerRejected.svg';
import payerCancelled from 'assets/images/icons/payerCancelled.svg';
import payerAccepted from 'assets/images/icons/payerAccepted.svg';
import payerRequired from 'assets/images/icons/payerRequired.svg';
import unavailable from 'assets/images/icons/unavailable.svg';
import rotate from 'assets/images/icons/rotate.svg';
import arrowUpRight from 'assets/images/icons/arrowUpRight.svg';
import secondaryReady from 'assets/images/icons/secondayReady.svg';
import secondarySubmitted from 'assets/images/icons/secondarySubmitted.svg';
import secondaryReadySubmitted from 'assets/images/icons/readySubmitted.svg';
import completeStar from 'assets/images/icons/completeStar.svg';
import uploadedVideo from 'assets/images/icons/uploadedVideo.svg';
import videos from 'assets/images/icons/videos.svg';
import noteNewStyle from 'assets/images/icons/noteNewStyle.svg';
import playButton from 'assets/images/icons/playButton.svg';
import voidCircle from 'assets/images/icons/voidCircle.svg';
import zoom from 'assets/images/icons/zoom.svg';
import chatIcon from 'assets/images/icons/chatIcon.svg';

import jpg from 'assets/images/icons/jpg.svg';
import pdf from 'assets/images/icons/pdf.svg';
import png from 'assets/images/icons/png.svg';
import ppt from 'assets/images/icons/ppt.svg';
import jpeg from 'assets/images/icons/jpeg.svg';
import svgFile from 'assets/images/icons/svgFile.svg';
import archivedPng from 'assets/images/icons/archivedPng.svg';
import archivedSvg from 'assets/images/icons/archivedSvg.svg';
import archivedJpg from 'assets/images/icons/archivedJpg.svg';
import archivedPdf from 'assets/images/icons/archivedPdf.svg';
import archivedPpt from 'assets/images/icons/archivedPPt.svg';
import archivedJpeg from 'assets/images/icons/archivedJpeg.svg';
import sendIcon from 'assets/images/icons/sendIcon.svg';
import unShare from 'assets/images/icons/unShare.svg';
import fileBlueIcon from 'assets/images/icons/fileBlueIcon.svg';
import documentTextBlue from 'assets/images/icons/documentTextBlue.svg';
import fileRedIcon from 'assets/images/icons/fileRedIcon.svg';
import duplicateIcon from 'assets/images/icons/duplicateIcon.svg';
import blackSmallTrash from 'assets/images/icons/blackSmallTrash.svg';
import attributeText from 'assets/images/icons/attributeText.svg';
import attributeCheckBox from 'assets/images/icons/attributeCheckBox.svg';
import attributeDropDown from 'assets/images/icons/attributeDropDown.svg';
import attributeGoal from 'assets/images/icons/attributeGoal.svg';
import attributeRadio from 'assets/images/icons/attributeRadio.svg';
import attributeDate from 'assets/images/icons/attributeDate.svg';
import attributeSignature from 'assets/images/icons/attributeSignature.svg';
import attributeSessionDataTable from 'assets/images/icons/attributeSessionDataTable.svg';
import attributeTable from 'assets/images/icons/attributeTable.svg';
import attributeTextEditor from 'assets/images/icons/attributeTextEditor.svg';
import attributeUpload from 'assets/images/icons/attributeUpload.svg';
import dragIcon from 'assets/images/icons/draggIcon.svg';
import layoutIcon from 'assets/images/icons/layoutIcon.svg';
import contentIcon from 'assets/images/icons/contentIcon.svg';
import behaivorIcon from 'assets/images/icons/behaivorIcon.svg';
import removeRow from 'assets/images/icons/removeRow.svg';
import chartIconUp from 'assets/images/icons/chartIconUp.svg';
import builderGoal from 'assets/images/icons/builderGoal.svg';
import graphAttribute from 'assets/images/icons/graphAttribute.svg';
import editPenUnderline from 'assets/images/icons/editPenUnderline.svg';
import chartTextBehavior from 'assets/images/icons/chartTextBehavior.svg';
import chartSeries from 'assets/images/icons/chartSeries.svg';
import customizeChart from 'assets/images/icons/customizeChart.svg';
import database from 'assets/images/icons/database.svg';
import sections from 'assets/images/icons/sections.svg';
import customSections from 'assets/images/icons/customSections.svg';
import taskTab from 'assets/images/icons/taskTab.svg';
import taskTabActive from 'assets/images/icons/taskTabActive.svg';
import atASign from 'assets/images/icons/atAsign.svg';
import refreshWhite from 'assets/images/icons/refreshWhite.svg';
import officeBlueIcon from 'assets/images/icons/officeBlueIcon.svg';
import officeMarkLocation from 'assets/images/icons/officeMarkLocation.svg';
import documentLayoutFooter from 'assets/images/icons/documentLayoutFooter.svg';
import documentLayoutHeader from 'assets/images/icons/documentLayoutHeader.svg';
import grouppedFrame from 'assets/images/icons/grouppedFrame.svg';
import nonBilAble from 'assets/images/icons/nonBilable.svg';
import plusSquare from 'assets/images/icons/plusSquare.svg';
import googleMeet from 'assets/images/icons/googleMeet.svg';
import sessionEditGoal from 'assets/images/icons/sessionEditGoal.svg';
import releaseNotes from 'assets/images/icons/releaseNotes.svg';
import releaseNotesActive from 'assets/images/icons/releaseNotesActive.svg';
import cancelCircle from 'assets/images/icons/cancelCircle.svg';
import shield from 'assets/images/icons/shield.svg';
import undoForm from 'assets/images/icons/undoForm.svg';
import redoForm from 'assets/images/icons/redoForm.svg';
import pageSettings from 'assets/images/icons/pageSettings.svg';
import lockGray from 'assets/images/icons/lockGray.svg';
import xCircleRed from 'assets/images/icons/xCircleRed.svg';
import userInvite from 'assets/images/icons/userInvite.svg';
import postedNote from 'assets/images/icons/postedNote.svg';
import authorizationUtilization from 'assets/images/icons/authorizationUtilization.svg';
import richTextGoalBlock from 'assets/images/icons/richTextGoalBlock.svg';
import billingAndDiagnosis from 'assets/images/icons/billingAndDiagnosis.svg';

export const Images = {
    billingAndDiagnosis,
    richTextGoalBlock,
    authorizationUtilization,
    clientAbcData,
    assignedStaff,
    availityIntegrated,
    createAccountAvaility,
    manageFtp,
    ftpAndEdi,
    availityWeb,
    isReadyGreen,
    systemAllyGuide,
    sftpIntegration,
    checkedVerify,
    setupGuide,
    postedNote,
    staffCompliance,
    otherSettingsAi,
    otherSettingsBcba,
    otherSettingsElig,
    userInvite,
    xCircleRed,
    formHistory,
    dollarIcon,
    commentChatIcon,
    replyIcon,
    secondaryNotBilledFlag,
    messageCircle,
    messageCircleBlue,
    signIcon,
    clientSessionNotesDock,
    clientNotesDock,
    clientProggressReport,
    supervizeBigEye,
    supervizeEye,
    checkedMarkGreen,
    checkTickGreen,
    lockSmallGreen,
    lockGray,
    pageSettings,
    shield,
    undoForm,
    redoForm,
    cancelCircle,
    releaseNotesActive,
    releaseNotes,
    sessionEditGoal,
    plusSquare,
    googleMeet,
    nonBilAble,
    grouppedFrame,
    documentLayoutHeader,
    documentLayoutFooter,
    officeMarkLocation,
    officeBlueIcon,
    refreshWhite,
    atASign,
    customSections,
    sections,
    customizeChart,
    chartSeries,
    database,
    chartTextBehavior,
    editPenUnderline,
    graphAttribute,
    builderGoal,
    chartIconUp,
    removeRow,
    behaivorIcon,
    contentIcon,
    layoutIcon,
    dragIcon,
    attributeText,
    attributeCheckBox,
    attributeDropDown,
    attributeGoal,
    attributeRadio,
    attributeDate,
    attributeSignature,
    attributeSessionDataTable,
    attributeTable,
    attributeTextEditor,
    attributeUpload,
    blackSmallTrash,
    duplicateIcon,
    formRichText,
    sectionFolder,
    formPreview,
    builder,
    chatIcon,
    linkIcon,
    zoom,
    fileRedIcon,
    fileBlueIcon,
    documentTextBlue,
    sendIcon,
    unShare,
    archivedSvg,
    archivedJpg,
    archivedPdf,
    archivedPpt,
    archivedJpeg,
    archivedPng,
    jpg,
    pdf,
    png,
    ppt,
    jpeg,
    svgFile,
    unarchive,
    archive,
    completeStar,
    playButton,
    noteNewStyle,
    videos,
    uploadedVideo,
    voidCircle,
    infoGrayIcon,
    arrowUpRight,
    secondaryReadySubmitted,
    secondarySubmitted,
    secondaryReady,
    receipt,
    secondaryBilling,
    secondaryBillingFilled,
    rotate,
    unavailable,
    payerRequired,
    payerPending,
    payerRejected,
    payerCancelled,
    payerAccepted,
    claimSubmitPNotFill,
    claimSubmitDNotFill,
    claimSubmitINotFill,
    claimSubmitI,
    claimSubmitD,
    claimSubmitP,
    checkCircleBlue,
    checkCircleBlueTransparent,
    personIcon,
    worked,
    truck,
    map,
    apptsCalendar,
    clock,
    masteredTarget,
    filterAdd,
    downloadTargetPdf,
    taskTab,
    taskTabActive,
    dashboardTab,
    dashboardTabActive,
    availity,
    eventCalendar,
    addAbc,
    arrowUpGray,
    resetTimer,
    slash,
    warningInfo,
    blockedForm,
    sessionMode,
    sessionTypes,
    sessionDomains,
    sessionTag,
    stopCircle,
    play,
    sessionList,
    pushPin,
    pauseCircle,
    sessionGrid,
    backArrow,
    formStaffNotes,
    formAbcNotes,
    formClientNotes,
    formInvoiceNotes,
    formTimesheetNotes,
    formClinicalNotes,
    formFsNotes,
    formClaimNotes,
    formOfficeNotes,
    minusRemoveCircle,
    startBuildingForm,
    deleteFormItem,
    appealed,
    notAppealed,
    noteTab,
    historyTab,
    fileTab,
    commentCircle,
    verified,
    verifiedBadge,
    defaultBadge,
    updateStatuses,
    providerIcon,
    messageEdit,
    minusCircle,
    eligibleNotes,
    eligibilityFail,
    eligibilityExpired,
    eligibilityChecked,
    userCheckEligibility,
    pieLineChart,
    insightsChart,
    layer,
    folderIcon,
    folderMain,
    revertWhite,
    fileBlack,
    undo,
    eyeWhite,
    completeIcon,
    closeSingleVector,
    staffPassword,
    openSafearea,
    cloeSafearea,
    relatedLink,
    stripe,
    mail,
    userCheck,
    userPlus,
    signatureHere,
    duplicateFormLine,
    editSetting,
    backBtn,
    fGoal,
    fPageBreak,
    fDivider,
    fDatePicker,
    fMultipleChoice,
    fAvailability,
    fSingleLine,
    fName,
    fPhone,
    fEmail,
    fAddress,
    fSignature,
    fUpload,
    fHeading,
    fLongText,
    formIcon,
    formTab,
    formTabActive,
    infoCircle,
    infoCircleGray,
    redTrashLine,
    chevronDown,
    signaturePenBlue,
    signedSuccessCheck,
    shieldTickGray,
    duplicate,
    uploadDockCloud,
    briefcase,
    sessionOfficeNote,
    clientOfficeNote,
    revertIcon,
    actualTimeWhite,
    actualTime,
    pastEmployment,
    arrowUp,
    arrowDown,
    calendar,
    primaryStar,
    emptyStateIllustrations,
    editDarkBlue,
    toolOfficeNote,
    toolClinicalNote,
    clinicalNote,
    tableNotes,
    officeNotes,
    apptNoteIcon,
    alertWarning,
    alertError,
    arrowOrangeRight,
    repeatAppt,
    moreGrayIcon,
    apptCalendar,
    save,
    xCircle,
    copyAuth,
    editAuth,
    fileAuth,
    businessCenter,
    refreshSelect,
    signatureRemove,
    coinStack,
    onlineSupport,
    helpIcon,
    helpIconActive,
    closeExWhite,
    selectAll,
    compareArrows,
    officeAlly,
    closeChip,
    closeChipBlue,
    tagUser,
    deleteTag,
    moreGray,
    dragIndicatorBlue,
    dragIndicator,
    lineChart,
    barChart,
    pieChart,
    noAnalyticYet,
    added,
    addCircleBlue,
    clientWidget,
    fsWidget,
    payrollWidget,
    staffWidgets,
    apptWidget,

    trendDown,
    trendUp,
    closeGray,
    searchIcon,
    generateReportWhite,
    generateReport,
    apptComplete,
    apptAlert,
    apptCancelled,
    apptEdited,
    newApptCreated,
    newServiceAdded,
    noNotifications,
    danger,
    notification,
    signatureDate,
    signatureFile,
    signatureLocation,
    clearSignature,
    alreadyUploadedSignatureIcon,
    signatureIcon,
    removeBlack,
    fsClients,
    staffCredential,
    inactivatePayCode,
    copy,
    editPen,
    addBlackIcon,
    showAyeBlue,
    folder,
    toolInfoIcon,
    recurDark,
    editDark,
    uploadSignature,
    manageNote,
    emptyFolder,
    noCredential,
    noUpcomingAppointment,
    noRole,
    noCalendar,
    noPendingClaim,
    noAccess,
    noDashboard,
    noContact,
    noService,
    notFile,
    noHistory,
    noNote,
    noClientYet,
    noFsYet,
    noAppt,
    blueFlag,
    generateInfoIcon,
    whiteInfoIcon,
    yellowFlag,
    downloadCloudBlue,
    refresh,
    flag,
    checkMarkBlack,
    editDockBlack,
    uploadCloudBlack,
    billingTabActive,
    clientTabActive,
    fsTabActive,
    payrollTabActive,
    postingTabActive,
    reportTabActive,
    roleTabActive,
    scheduleTabActive,
    staffTabActive,
    systemTabActive,
    redTrash,
    leftSideIcon,
    chatSupport,
    billingTab,
    clientTab,
    fsTab,
    payrollTab,
    postingTab,
    reportTab,
    roleTab,
    scheduleTab,
    staffTab,
    systemTab,
    libraryTab,
    libraryTabActive,
    resourceTab,
    resourceTabActive,
    toolsTab,
    toolsTabActive,
    fsIcon,
    grayTrash,
    complete,
    uploadedFile,
    uploadCloud,
    uploadTrayBlue,
    trash,
    closeButton,
    uploadAvatar,
    authFile,
    CSVFile,
    JPEGFile,
    PDFFile,
    PNGFile,
    noFile,
    showEye,
    hideEye,
    editBlack,
    deleteLicenseIcon,
    timePast,
    documentUpload,
    editTemplate,
    noteEdit,
    noteCalendar,
    noteClock,
    staffPosition,
    removeAddress,
    alertTriangle,
    accessManagementOutlineGray,
    client,
    tableSortBlue,
    tableSortGray,
    downloadCloudWhite,
    grayLocation,
    callCalling,
    sms,
    downloadCloud,
    authUtilization,
    logoSmall,
    accessManagementIcon,
    minimize,
    timelapse,
    expandFull,
    calendarToday,
    arrowRight,
    filters,

    accessTime,
    appleCalendar,
    googleCalendar,
    pastAuthorizations,
    cloudUpload,
    externalLink,
    note,
    link,
    scheduleGroup,
    scheduleList,
    scheduleTime,
    reinvite,
    office,
    repetApptBlue,
    repetAppt,
    apptGeneralInfo,
    reConnectedTemplate,
    connectedTemplate,
    closeBlackVector,
    uploadImage,
    grayCalendar,
    grayEdit,
    notes,
    selectCredential,
    rightDropdownArrowBlue,
    licenseIcon,
    uncheckCredential,
    checkCredential,
    verify,
    call,
    emailGray,
    insurance,
    lock,
    unlock,
    toolInfoBlack,
    starVector,
    locationGray,
    time,
    dropDown,
    dropUp,
    editGray,
    east,
    payrollActive,
    payrollPassive,
    blueBlackLogo,
    logo,
    reportsTab,
    downloadPdf,
    reportGray,
    reportBlue,
    addIconAndCircle,
    bigDownload,
    closeVector,
    hours,
    showDock,
    deleteDock,
    editDock,
    downloadDock,
    document,
    upload,
    aboutInformation,
    greenMark,
    darkGrayDone,
    bigEmployment,
    portfolio,
    moreInfo,
    addBluePlus,
    plusSimple,
    plus,
    doctors: doctors,
    phone: phone,
    fundingSourceActive: fundingSourceActive,
    fundingSourcePassive: fundingSourcePassive,
    staffActive: staffActive,
    staffPassive: staffPassive,
    addCircle: addCircle,
    fundingSourceOutline: fundingSourceOutline,
    roleManagementActive: roleManagementActive,
    roleManagementPassive: roleManagementPassive,
    addYellowIcon: addYellowIcon,
    addHours: addHours,
    authIconGen: authIconGen,
    error: error,
    aToZ: aToZ,
    zToA: zToA,
    checked: checked,
    userProfile: userProfile,
    email: email,
    bluePhone: bluePhone,
    location: location,
    edit: edit,
    signOut: signOut,
    staffOutline: staffOutline,
    generalInfoIcon: generalInfoIcon,
    address: address,
    otherDetailsIcon: otherDetailsIcon,
    remove: remove,
    addLight: addLight,
    addLight2: addLight2,
    clientActive: clientActive,
    clients: clients,
    clientsPassive: clientsPassive,
    clientModalicon1: clientModalicon1,
    clientModalicon2: clientModalicon2,
    clientModalicon3: clientModalicon3,
    checkmark: checkmark,
    systemActive: systemActive,
    systemPassive: systemPassive,
    systemIcon: systemIcon,
    authIcon: authIcon,
    errorIcon: errorIcon,
    successIcon: successIcon,
    infoIcon: infoIcon,
    addIcon: addIcon,
    employment: employment,
    fileIcon: fileIcon,
    eventsFill: eventsFill,
    download: download,
    forward: forward,
    authEdit: authEdit,
    recurrance: recurrance,
    pngIcon: pngIcon,
    jpegIcon: jpegIcon,
    pdfIcon: pdfIcon,
    csvIcon: csvIcon,
    removeIcon: removeIcon,
    eventsPassive: eventsPassive,
    accessManagementFill: accessManagementFill,
    accessManagementOutline: accessManagementOutline,
    dropdownArrow,
    dropdownArrowBlue,
    dropdownArrowUpBlue,
    dropdownBlue,
    search,
    checkmarkWhite,
    dropdownArrowFilledBlue,
    billingFill,
    billingPassive,
    accordArrowBlue,
    accordArrowBlack,
    latestEarliest,
    billingOutline,
    addOrange,
    aToZWhite,
    latestEarliestWhite,
    dropdownArrowWhite,
    claimInfo,
    checkmarkBlue,
    uncheck,
    postingFill,
    postingPassive,
    success,
    successGreen,
    editPmt,
    forwardBlue,
    addLightIcon,
    infoWhiteIcon,
    warning,
    earliestLatestBlue,
    show,
    toolInfo,
    // chatIcon,
};
